import { BillProjectionEntryCta } from '@/app/home-solar/bill-projection/components';
import { GetStartedCta, Subscribe } from '@/app/lp/components';
import { TRACKING } from '@/helpers/tracking';

// The 8 bill-shock entry pages (bill-projection brief): these swap the generic
// post-footer CTA for the Bill Projection entry CTA — replace, never coexist
export const BILL_SHOCK_SLUGS = new Set([
  'a-guide-to-peak-and-off-peak-hours-for-electricity',
  'how-many-watts-does-a-fridge-use',
  'how-many-watts-does-a-space-heater-use',
  'how-many-watts-does-a-tv-use',
  'how-many-watts-does-ac-use',
  'kw-vs-kwh',
  'solar-panels-electric-bill',
  'why-is-my-electric-bill-so-high',
]);

type Props = {
  page?: string;
  slug: string;
};

export const BlogPostCta = ({ page, slug }: Props) =>
  BILL_SHOCK_SLUGS.has(slug) ? (
    <BillProjectionEntryCta page={page} />
  ) : (
    <GetStartedCta eventName={TRACKING.BLOG_GET_QUOTE}>
      <Subscribe buttonText="Subscribe" variant="primary" />
    </GetStartedCta>
  );
